import styled, { css } from 'styled-components';
import Flex from '@deprecated-ui/common/Flex';
import Button from '@deprecated-ui/common/Button';
import color from '@deprecated-ui/_style/color';
import device from '@deprecated-ui/_style/device';
import Image from 'global/Image';

const IconFooterWrapper = styled.button.attrs({
  type: 'button',
})`
  background-color: transparent;
  border: none;
  color: ${color.midgray};
  cursor: pointer;
  padding: 0px;
  width: 34px;
  height: 28px;
  margin-right: 6px;
  :hover {
    color: ${color.primary};
  }
`;

const FooterContainer = styled(Flex).attrs({
  align: 'center',
  justify: 'space-between',
  wrap: 'wrap',
})`
  padding: 0 20px 20px;
  width: 100%;
  margin-top: 26px;

  ${
    // @ts-expect-error
    ({ repost }) =>
    repost &&
    css`
      width: auto;
    `}
`;

const FooterIcon = styled(Image)`
  max-height: 16px;
`;

const ButtonPinned = styled(Button)`
  padding: 4px 10px;

  img.compose-pin-icon {
    height: 16px;
    width: 16px;
    margin-right: 5px;
  }
`;

const ButtonSubmit = styled(Button)`
  &:disabled {
    background: #8cd9bc !important;
    color: ${color.light};
    border: none;
  }

  ${({ loading }) =>
    loading &&
    css`
      margin-left: 5px;
    `}
`;

const EmojiContainer = styled.div`
  position: fixed;
  bottom: 25px;
  width: 100%;
  border-top: 1px solid ${color.gainsboro};
  padding: 0;
  @media ${device.tablet} {
    position: relative;
    bottom: unset;
  }
`;

const GifContainer = styled.div`
  position: fixed;
  bottom: 25px;
  width: 100%;
  border-top: 1px solid ${color.gainsboro};
  padding: 20px 20px 10px 20px;
  @media ${device.tablet} {
    position: relative;
    bottom: unset;
    padding: 20px 20px 0px 20px;
  }
`;

export {
  IconFooterWrapper,
  FooterContainer,
  FooterIcon,
  ButtonPinned,
  ButtonSubmit,
  EmojiContainer,
  GifContainer,
};
